export const Exam = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.26 6.31333C17.0378 6.12833 16.7768 5.99572 16.4963 5.92532C16.2159 5.85493 15.9232 5.84855 15.64 5.90667C15.319 5.96713 14.9932 5.99837 14.6666 6C13.8462 5.99827 13.0385 5.79692 12.3133 5.41333C11.3966 4.92293 10.373 4.66646 9.33332 4.66667C8.65332 4.6659 7.97775 4.77624 7.33333 4.99333V4.66667C7.33333 4.48986 7.26309 4.32029 7.13807 4.19526C7.01304 4.07024 6.84348 4 6.66666 4C6.48985 4 6.32029 4.07024 6.19526 4.19526C6.07024 4.32029 6 4.48986 6 4.66667V19.3333C6 19.5101 6.07024 19.6797 6.19526 19.8047C6.32029 19.9298 6.48985 20 6.66666 20C6.84348 20 7.01304 19.9298 7.13807 19.8047C7.26309 19.6797 7.33333 19.5101 7.33333 19.3333V13.0867C8.02441 12.7838 8.77514 12.6415 9.52912 12.6703C10.2831 12.6992 11.0207 12.8985 11.6866 13.2533C12.4405 13.6556 13.2678 13.9014 14.1191 13.9759C14.9703 14.0503 15.8277 13.952 16.64 13.6867C17.038 13.5538 17.3839 13.2985 17.6281 12.9572C17.8724 12.616 18.0025 12.2063 18 11.7867V7.87333C18.0001 7.57468 17.9338 7.27974 17.8058 7.0099C17.6778 6.74007 17.4914 6.50212 17.26 6.31333Z"
        fill="currentColor"
      />
    </svg>
  );
};
